import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'
import Vue from 'vue'

const state = {
  initLoaded: false,
  categoryGroup: {
    name: '',
    tag: '',
    publish_setting: '1',
    contract_flag: 2,
    conditions: {}
  },
  productCategoryList: [],
  message: {
    content: '',
    type: ''
  }
}

const actions = {
  /**
   * category groupデータ取得
   */
  async getCategoryGroup ({ state, commit }, id) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('CategoryGroup').categoryGroupDetail(id)
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      this.dispatch('loading/loadingPageMinus')
      return response.data
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
      commit('setMessage', { content: response.data.data.message, type: type })
    }
    this.dispatch('loading/loadingPageMinus')
  },

  async getProductCategoryList ({ state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    let type = 'success'
    const param = {
      code: Vue.localStorage.get('groupMode')
    }
    let resConst = await ApiManager.request('Analyze').analyzeInit(param)
    if (resConst.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setProductCategoryList', resConst.data.data)
    } else if (resConst.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: resConst.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  },

  /**
   * 新規と更新処理を行う
   */
  async updateCategoryGroup ({ state, commit }, categoryGroup) {
    this.dispatch('loading/loadingPagePlus')
    let response = null
    if (categoryGroup.id) {
      response = await ApiManager.request('CategoryGroup').categoryGroupEdit(categoryGroup)
    } else {
      categoryGroup.analyze_target_code = Vue.localStorage.get('groupMode')
      response = await ApiManager.request('CategoryGroup').categoryGroupAdd(categoryGroup)
    }
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  }
}

const mutations = {
  init (state, data) {
    // 初期ローディングの終了
    state.initLoaded = true
  },
  setMessage (state, data) {
    state.message = data
  },
  setProductCategoryList (state, data) {
    state.productCategoryList = data.product_category
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
